// extracted by mini-css-extract-plugin
export default {"goodThing":"index_goodThing_k18nd","imageMark":"index_imageMark_SA5X1"};